// extracted by mini-css-extract-plugin
module.exports = {"section":"VerticalCardList_section__N8enh","title":"VerticalCardList_title__1usXN","horizontalSectionDivider":"VerticalCardList_horizontalSectionDivider__npwjT"};